export const getContactInfoHash = ({ companyName, userInfo, }) => {
    return companyName + '~' + userInfo.fullName + '~' + userInfo.phoneNumber;
};
